import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

export const ApplicationReviewDialogSkeleton: React.FC = () => {
  return (
    <Stack spacing={2}>
      {/* Operator Information skeleton */}
      <Box>
        <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width={200} height={28} />
        <Skeleton variant="text" width={180} height={20} />
        <Skeleton variant="text" width={160} height={20} />
      </Box>

      <Divider />

      {/* Application Details skeleton */}
      <Box>
        <Skeleton variant="text" width={140} height={20} sx={{ mb: 1 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={120} height={24} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width={80} height={16} />
            <Skeleton variant="text" width={140} height={24} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Skeleton variant="text" width={100} height={16} />
            <Skeleton variant="text" width={60} height={24} />
          </Grid>
        </Grid>
      </Box>

      <Divider />

      {/* Vehicles skeleton */}
      <Box>
        <Skeleton variant="text" width={100} height={24} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" width="100%" height={60} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" width="100%" height={60} />
      </Box>

      <Divider />

      {/* Documents skeleton */}
      <Box>
        <Skeleton variant="text" width={120} height={24} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" width="100%" height={80} sx={{ mb: 1 }} />
        <Skeleton variant="rounded" width="100%" height={80} />
      </Box>
    </Stack>
  );
};

export default ApplicationReviewDialogSkeleton;
